const PinLocationIcon = ({ active }) => {
  return (
    <svg width='26' height='25' viewBox='0 0 100 125' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M53.158,5.158C53.158,3.414,51.744,2,50,2s-3.158,1.414-3.158,3.158v11.244c-16.12,1.513-28.951,14.327-30.487,30.44H5.158  C3.414,46.842,2,48.256,2,50s1.414,3.158,3.158,3.158h11.183c1.455,16.201,14.319,29.109,30.501,30.628v11.056  C46.842,96.586,48.256,98,50,98s3.158-1.414,3.158-3.158v-11.05c16.222-1.481,29.13-14.405,30.587-30.634h11.097  C96.586,53.158,98,51.744,98,50s-1.414-3.158-3.158-3.158H83.731c-1.539-16.142-14.413-28.971-30.573-30.446V5.158z M77.574,50.094  c0,15.181-12.35,27.531-27.531,27.531s-27.531-12.35-27.531-27.531s12.35-27.531,27.531-27.531S77.574,34.913,77.574,50.094z'
        fill='#58c1f5'
      />
      <path
        fill='#58c1f5'
        d='M36.1,50.046c0,7.662,6.233,13.895,13.895,13.895S63.89,57.708,63.89,50.046s-6.233-13.895-13.895-13.895  S36.1,42.385,36.1,50.046z M57.574,50.046c0,4.179-3.4,7.579-7.579,7.579s-7.579-3.4-7.579-7.579s3.4-7.579,7.579-7.579  S57.574,45.867,57.574,50.046z'
      />
    </svg>
  );
};

export default PinLocationIcon;
